export enum AuthenticationErrorCode {
	SingleApplicantFinished = 'SingleApplicantFinished',
	CoApplicantFinished = 'CoApplicantFinished',
	BothApplicantsFinished = 'BothApplicantsFinished',
}
